import React from 'react';
// src/components/BottomNav.jsx — 5 most used pages
import { useApp } from '../context/AppContext';
import { G } from '../constants';

function BottomNav() {
  const { page, setPage, bg2, bord, tx2 } = useApp();
  const items = [
    ['🏠','home','Home'],
    ['📈','trade','Trade'],
    ['🛍️','store','Store'],
    ['🏆','leaderboard','Ranks'],
    ['🎮','gamification','Earn'],
    ['📊','positions','Positions'], // v197a Task 1: Profile moved to Sidebar, Positions in nav
  ];

  return (
    <div style={{ position:'fixed', bottom:0, left:0, right:0, height:54, background:bg2, borderTop:`1px solid ${bord}`, display:'flex', zIndex:99 }}>
      {items.map(([icon, pg, label]) => (
        <div key={pg} onClick={() => setPage(pg)}
          style={{ flex:1, display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', cursor:'pointer',
            color: page === pg ? G : tx2,
            borderTop: `2px solid ${page === pg ? G : 'transparent'}`,
            transition:'all 0.2s' }}>
          <div style={{ fontSize:19 }}>{icon}</div>
          <div style={{ fontSize:9, fontWeight:700, letterSpacing:0.3, marginTop:1 }}>{label}</div>
        </div>
      ))}
    </div>
  );
}

export default React.memo(BottomNav);
